// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* games/wordle/Wordle.css */

.wordle-board-container {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #121826;
  background-image: radial-gradient(circle at center, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 1) 100%);
  display: flex;
  flex-direction: column;
  color: #f8fafc;
  /* Используем env() для отступа от "зоны управления" телефона + стандартные 20px */
  padding: 7px 5px calc(20px + var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom))) 5px;
  box-sizing: border-box;
  z-index: 6000;
  -webkit-user-select: none;
          user-select: none;
  touch-action: none;
  overflow: hidden;
}

/* === КОМПАКТНЫЙ СТИЛЬНЫЙ HEADER === */
.wordle-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 15px;
  margin: 0 5px 10px 5px;
  background: rgba(255, 255, 255, 0.05); /* Рамочка только для хедера */
  border-radius: 6px;
  border: 1px solid rgba(255,255,255,0.08);
  flex-shrink: 0;
}

.wordle-title {
  font-size: 16px;
  font-weight: 900;
  color: #fbbf24;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.wordle-stats {
  display: flex;
  gap: 15px;
  font-size: 14px;
  font-weight: bold;
  color: #cbd5e1;
}

.wordle-timer { 
  width: 40px; 
  text-align: right;
  font-weight: 500;
 }

/* === СЕТКА === */
.wordle-grid-wrapper {
  flex: 1 1;
  min-height: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 11px;
  overflow: hidden;
}

.wordle-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
  aspect-ratio: var(--cols) / var(--rows, 6);
  height: 100%;
  max-height: 60vh; /* Ограничение высоты теперь здесь */

  /* Оставляем 20px по бокам, чтобы иконка вопроса точно влезла */
  max-width: calc(100% - 40px);
  margin: 0 auto;
}

.wordle-row {
  display: flex;
  gap: 6px;
  flex: 1 1;
  width: 100%;
  position: relative; /* Для позиционирования иконки вопроса */
}

/* Иконка определения слова */
.wordle-question-icon {
  position: absolute;
  right: -26px; /* Выносим за пределы ряда */
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.2);
  font-size: 14px;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.wordle-row:hover .wordle-question-icon,
.wordle-question-icon:active {
  color: #ffffffc7;
}

.wordle-cell {
  flex: 1 1;
  background: rgba(0,0,0,0.25);
  border: 2px solid #334155;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: clamp(20px, 6vw, 27px); /* Адаптивный размер шрифта */
  font-weight: 900;
  text-transform: uppercase;
  color: #f8fafc;
  box-sizing: border-box;
  line-height: 1;
  cursor: pointer; /* Показывает, что можно кликать для тултипа */
}

/* === ПРИГЛУШЕННЫЕ ПАСТЕЛЬНЫЕ ЦВЕТА === */
.wordle-cell.filled { background: #334155; border-color: #475569; animation: popIn 0.1s ease-out; }
.wordle-cell.correct { background: #40c649; border-color: #44ce46; color: #102a1a; }
.wordle-cell.present { background: #fbbf24; border-color: #fbbf24; color: #451a03; }
.wordle-cell.absent  { background: #334155; border-color: #334155; color: #94a3b8; }
.wordle-cell.missed  { background: #f87171; border-color: #f87171; color: #450a0a; }

@keyframes popIn {
  0% { transform: scale(0.9); } 50% { transform: scale(1.05); } 100% { transform: scale(1); }
}

.wordle-row.shake { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }
@keyframes shake {
  10%, 90% { transform: translate3d(-2px, 0, 0); }
  20%, 80% { transform: translate3d(4px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-6px, 0, 0); }
  40%, 60% { transform: translate3d(6px, 0, 0); }
}

/* === НИЖНЯЯ ПАНЕЛЬ (КНОПКА + КЛАВИАТУРА) === */
.wordle-bottom-area {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  margin-top: auto; /* Гарантированно отталкивает клавиатуру в самый низ */
}

.wordle-surrender-btn {
  width: 100%;
  height: 36px;
  background: rgba(255, 255, 255, 0.05);
  color: #94a3b8;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 8px; /* Отступ до клавиатуры */
  cursor: pointer;
  transition: all 0.2s;
}

.wordle-surrender-btn:active {
  background: rgba(239, 68, 68, 0.2);
  color: #ef4444;
  border-color: rgba(239, 68, 68, 0.5);
  transform: translateY(2px);
}

.wordle-keyboard {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.wk-row { display: flex; justify-content: center; gap: 4px; }

.wk-key {
  flex: 1 1;
  height: 52px;
  background: #cbd5e1;
  color: #0f172a;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 3px 0 #94a3b8;
  transition: transform 0.1s;
  padding: 0;
}

.wk-key:active { transform: translateY(3px); box-shadow: 0 0 0 transparent; }
.wk-key.wide { flex: 1.5 1; font-size: 14px; }

/* Цвета клавиатуры */
.wk-key.correct { background: #40c649; color: #102a1a; box-shadow: 0 3px 0 #26ad2f; }
.wk-key.present { background: #fbbf24; color: #451a03; box-shadow: 0 3px 0 #f59e0b; }
.wk-key.absent  { background: #475569; color: #cbd5e1; box-shadow: 0 3px 0 #334155; }


/* === ОБРАЗОВАТЕЛЬНЫЙ ТУЛТИП === */
.wordle-tooltip {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 400px;
  max-height: 33vh;
  background: rgba(15, 23, 42, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid #7194b7;
  border-radius: 12px;
  padding: 10px;
  color: #f8fafc;
  box-shadow: 0 10px 30px rgba(0,0,0,0.8);
  z-index: 7000;
  overflow-y: auto;
  animation: tooltipFade 0.2s ease-out;
  cursor: pointer;
}

.wordle-tooltip-word {
  display: block;
  font-size: 16px;
  font-weight: 900;
  color: #eeb946;
  margin-bottom: 8px;
  border-bottom: 1px solid rgba(135, 200, 244, 0.3);
  padding-bottom: 4px;
}

.wordle-tooltip-def { font-size: 14px; line-height: 1.5; color: #cbd5e1; }

@keyframes tooltipFade {
  from { opacity: 0; transform: translate(-50%, 10px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}

/* Отдельный стиль для показа слова в Досье (Результатах) */
.report-target-word {
  display: flex;
  gap: 4px;
  justify-content: center;
  margin-bottom: 15px;
}
.report-target-char {
  width: 35px; height: 35px;
  display: flex; align-items: center; justify-content: center;
  font-size: 20px; font-weight: 900; color: #fff;
  border-radius: 4px; text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

.wordle-stamp-overlay { position: absolute; top: 15%; left: 0; right: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; z-index: 100; }
.wordle-stamp { padding: 10px 20px; font-size: 22px; font-weight: 900; text-transform: uppercase; border: 6px double #b91c1c; border-radius: 12px; background: rgba(255, 255, 255, 0.95); color: #b91c1c; box-shadow: 0 4px 15px rgba(0,0,0,0.3); transform: rotate(-10deg) scale(2); opacity: 0; animation: wdStampIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }
@keyframes wdStampIn { to { transform: rotate(-10deg) scale(1); opacity: 1; } }

/* === СТИЛИ ДЛЯ РЯДА-РАЗГАДКИ (ПРОИГРЫШ / СДАЧА) === */
.wordle-row.reveal-row {
  margin-top: 5px; 
}

.wordle-row.reveal-row .wordle-cell {
  /* scale уменьшает содержимое визуально, но физически блок занимает столько же места во flex-сетке */
  /* Это предотвращает смещение слова к центру экрана */
  transform: scale(0.9);
  opacity: 0.8; /* Слегка приглушаем для стиля */
}

.wordle-row.reveal-row:hover .wordle-question-icon {
  color: #ffffffc7;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/wordle/Wordle.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,eAAe;EACf,MAAM,EAAE,OAAO;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,uGAAuG;EACvG,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,kFAAkF;EAClF,+FAA+F;EAC/F,sBAAsB;EACtB,aAAa;EACb,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC,EAAE,8BAA8B;EACrE,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;CACjB;;AAED,kBAAkB;AAClB;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB,EAAE,oCAAoC;;EAEtD,+DAA+D;EAC/D,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,WAAW;EACX,kBAAkB,EAAE,wCAAwC;AAC9D;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,YAAY,EAAE,4BAA4B;EAC1C,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC,EAAE,6BAA6B;EAChE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,eAAe,EAAE,8CAA8C;AACjE;;AAEA,0CAA0C;AAC1C,sBAAsB,mBAAmB,EAAE,qBAAqB,EAAE,8BAA8B,EAAE;AAClG,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnF,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnF,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AACnF,uBAAuB,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEnF;EACE,KAAK,qBAAqB,EAAE,EAAE,MAAM,sBAAsB,EAAE,EAAE,OAAO,mBAAmB,EAAE;AAC5F;;AAEA,oBAAoB,wDAAwD,EAAE;AAC9E;EACE,WAAW,kCAAkC,EAAE;EAC/C,WAAW,iCAAiC,EAAE;EAC9C,gBAAgB,kCAAkC,EAAE;EACpD,WAAW,iCAAiC,EAAE;AAChD;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB,EAAE,sDAAsD;AAC1E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB,EAAE,yBAAyB;EAC7C,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA,UAAU,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE;;AAE5D;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,2BAA2B;EAC3B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,iBAAiB,0BAA0B,EAAE,6BAA6B,EAAE;AAC5E,eAAe,WAAS,EAAE,eAAe,EAAE;;AAE3C,qBAAqB;AACrB,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AACpF,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;AACpF,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,2BAA2B,EAAE;;;AAGpF,mCAAmC;AACnC;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,uCAAuC;EACvC,aAAa;EACb,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;AACrB;;AAEA,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEzE;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,gBAAgB,EAAE,WAAW;EAC9C,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA,wBAAwB,kBAAkB,EAAE,QAAQ,EAAE,OAAO,EAAE,QAAQ,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,oBAAoB,EAAE,YAAY,EAAE;AAC1K,gBAAgB,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,0BAA0B,EAAE,mBAAmB,EAAE,qCAAqC,EAAE,cAAc,EAAE,sCAAsC,EAAE,kCAAkC,EAAE,UAAU,EAAE,0EAA0E,EAAE;AAC9W,uBAAuB,KAAK,kCAAkC,EAAE,UAAU,EAAE,EAAE;;AAE9E,uDAAuD;AACvD;EACE,eAAe;AACjB;;AAEA;EACE,oGAAoG;EACpG,qDAAqD;EACrD,qBAAqB;EACrB,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* games/wordle/Wordle.css */\n\n.wordle-board-container {\n  position: fixed;\n  top: 0; left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #121826;\n  background-image: radial-gradient(circle at center, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 1) 100%);\n  display: flex;\n  flex-direction: column;\n  color: #f8fafc;\n  /* Используем env() для отступа от \"зоны управления\" телефона + стандартные 20px */\n  padding: 7px 5px calc(20px + var(--tg-safe-area-inset-bottom, env(safe-area-inset-bottom))) 5px;\n  box-sizing: border-box;\n  z-index: 6000;\n  user-select: none;\n  touch-action: none;\n  overflow: hidden;\n}\n\n/* === КОМПАКТНЫЙ СТИЛЬНЫЙ HEADER === */\n.wordle-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 3px 15px;\n  margin: 0 5px 10px 5px;\n  background: rgba(255, 255, 255, 0.05); /* Рамочка только для хедера */\n  border-radius: 6px;\n  border: 1px solid rgba(255,255,255,0.08);\n  flex-shrink: 0;\n}\n\n.wordle-title {\n  font-size: 16px;\n  font-weight: 900;\n  color: #fbbf24;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n}\n\n.wordle-stats {\n  display: flex;\n  gap: 15px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #cbd5e1;\n}\n\n.wordle-timer { \n  width: 40px; \n  text-align: right;\n  font-weight: 500;\n }\n\n/* === СЕТКА === */\n.wordle-grid-wrapper {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 11px;\n  overflow: hidden;\n}\n\n.wordle-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  aspect-ratio: var(--cols) / var(--rows, 6);\n  height: 100%;\n  max-height: 60vh; /* Ограничение высоты теперь здесь */\n\n  /* Оставляем 20px по бокам, чтобы иконка вопроса точно влезла */\n  max-width: calc(100% - 40px);\n  margin: 0 auto;\n}\n\n.wordle-row {\n  display: flex;\n  gap: 6px;\n  flex: 1;\n  width: 100%;\n  position: relative; /* Для позиционирования иконки вопроса */\n}\n\n/* Иконка определения слова */\n.wordle-question-icon {\n  position: absolute;\n  right: -26px; /* Выносим за пределы ряда */\n  top: 50%;\n  transform: translateY(-50%);\n  color: rgba(255, 255, 255, 0.2);\n  font-size: 14px;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n}\n\n.wordle-row:hover .wordle-question-icon,\n.wordle-question-icon:active {\n  color: #ffffffc7;\n}\n\n.wordle-cell {\n  flex: 1;\n  background: rgba(0,0,0,0.25);\n  border: 2px solid #334155;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: clamp(20px, 6vw, 27px); /* Адаптивный размер шрифта */\n  font-weight: 900;\n  text-transform: uppercase;\n  color: #f8fafc;\n  box-sizing: border-box;\n  line-height: 1;\n  cursor: pointer; /* Показывает, что можно кликать для тултипа */\n}\n\n/* === ПРИГЛУШЕННЫЕ ПАСТЕЛЬНЫЕ ЦВЕТА === */\n.wordle-cell.filled { background: #334155; border-color: #475569; animation: popIn 0.1s ease-out; }\n.wordle-cell.correct { background: #40c649; border-color: #44ce46; color: #102a1a; }\n.wordle-cell.present { background: #fbbf24; border-color: #fbbf24; color: #451a03; }\n.wordle-cell.absent  { background: #334155; border-color: #334155; color: #94a3b8; }\n.wordle-cell.missed  { background: #f87171; border-color: #f87171; color: #450a0a; }\n\n@keyframes popIn {\n  0% { transform: scale(0.9); } 50% { transform: scale(1.05); } 100% { transform: scale(1); }\n}\n\n.wordle-row.shake { animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both; }\n@keyframes shake {\n  10%, 90% { transform: translate3d(-2px, 0, 0); }\n  20%, 80% { transform: translate3d(4px, 0, 0); }\n  30%, 50%, 70% { transform: translate3d(-6px, 0, 0); }\n  40%, 60% { transform: translate3d(6px, 0, 0); }\n}\n\n/* === НИЖНЯЯ ПАНЕЛЬ (КНОПКА + КЛАВИАТУРА) === */\n.wordle-bottom-area {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto;\n  margin-top: auto; /* Гарантированно отталкивает клавиатуру в самый низ */\n}\n\n.wordle-surrender-btn {\n  width: 100%;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.05);\n  color: #94a3b8;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 900;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 8px; /* Отступ до клавиатуры */\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.wordle-surrender-btn:active {\n  background: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  border-color: rgba(239, 68, 68, 0.5);\n  transform: translateY(2px);\n}\n\n.wordle-keyboard {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  width: 100%;\n}\n\n.wk-row { display: flex; justify-content: center; gap: 4px; }\n\n.wk-key {\n  flex: 1;\n  height: 52px;\n  background: #cbd5e1;\n  color: #0f172a;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 900;\n  cursor: pointer;\n  display: flex; align-items: center; justify-content: center;\n  box-shadow: 0 3px 0 #94a3b8;\n  transition: transform 0.1s;\n  padding: 0;\n}\n\n.wk-key:active { transform: translateY(3px); box-shadow: 0 0 0 transparent; }\n.wk-key.wide { flex: 1.5; font-size: 14px; }\n\n/* Цвета клавиатуры */\n.wk-key.correct { background: #40c649; color: #102a1a; box-shadow: 0 3px 0 #26ad2f; }\n.wk-key.present { background: #fbbf24; color: #451a03; box-shadow: 0 3px 0 #f59e0b; }\n.wk-key.absent  { background: #475569; color: #cbd5e1; box-shadow: 0 3px 0 #334155; }\n\n\n/* === ОБРАЗОВАТЕЛЬНЫЙ ТУЛТИП === */\n.wordle-tooltip {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 90%;\n  max-width: 400px;\n  max-height: 33vh;\n  background: rgba(15, 23, 42, 0.95);\n  backdrop-filter: blur(10px);\n  border: 1px solid #7194b7;\n  border-radius: 12px;\n  padding: 10px;\n  color: #f8fafc;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.8);\n  z-index: 7000;\n  overflow-y: auto;\n  animation: tooltipFade 0.2s ease-out;\n  cursor: pointer;\n}\n\n.wordle-tooltip-word {\n  display: block;\n  font-size: 16px;\n  font-weight: 900;\n  color: #eeb946;\n  margin-bottom: 8px;\n  border-bottom: 1px solid rgba(135, 200, 244, 0.3);\n  padding-bottom: 4px;\n}\n\n.wordle-tooltip-def { font-size: 14px; line-height: 1.5; color: #cbd5e1; }\n\n@keyframes tooltipFade {\n  from { opacity: 0; transform: translate(-50%, 10px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n\n/* Отдельный стиль для показа слова в Досье (Результатах) */\n.report-target-word {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  margin-bottom: 15px;\n}\n.report-target-char {\n  width: 35px; height: 35px;\n  display: flex; align-items: center; justify-content: center;\n  font-size: 20px; font-weight: 900; color: #fff;\n  border-radius: 4px; text-shadow: 0 1px 2px rgba(0,0,0,0.3);\n}\n\n.wordle-stamp-overlay { position: absolute; top: 15%; left: 0; right: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; z-index: 100; }\n.wordle-stamp { padding: 10px 20px; font-size: 22px; font-weight: 900; text-transform: uppercase; border: 6px double #b91c1c; border-radius: 12px; background: rgba(255, 255, 255, 0.95); color: #b91c1c; box-shadow: 0 4px 15px rgba(0,0,0,0.3); transform: rotate(-10deg) scale(2); opacity: 0; animation: wdStampIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards; }\n@keyframes wdStampIn { to { transform: rotate(-10deg) scale(1); opacity: 1; } }\n\n/* === СТИЛИ ДЛЯ РЯДА-РАЗГАДКИ (ПРОИГРЫШ / СДАЧА) === */\n.wordle-row.reveal-row {\n  margin-top: 5px; \n}\n\n.wordle-row.reveal-row .wordle-cell {\n  /* scale уменьшает содержимое визуально, но физически блок занимает столько же места во flex-сетке */\n  /* Это предотвращает смещение слова к центру экрана */\n  transform: scale(0.9);\n  opacity: 0.8; /* Слегка приглушаем для стиля */\n}\n\n.wordle-row.reveal-row:hover .wordle-question-icon {\n  color: #ffffffc7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
